/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BladderIrrigationViewerAliases {
  BLADDER_IRRIGATION_FOOTER_PANEL = 'bladder-irrigation-footer-panel',
  BLADDER_IRRIGATION_LAYOUT = 'bladder-irrigation-layout',
  BLADDER_IRRIGATION_VIEWER_CONTEXTUAL_BAR = 'bladder-irrigation-viewer-contextual-bar',
  BLADDER_IRRIGATION_VIEWER_DECK = 'bladder-irrigation-viewer-deck',
  END_BLADDER_IRRIGATION = 'end-bladder-irrigation',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  MEDICATION_OR_SOLUTION_DETAILS_CARD_0 = 'medication-or-solution-details-card-0',
  PANEL_BLADDER_IRRIGATION_VIEWER_CONTENT = 'panel-bladder-irrigation-viewer-content',
  PANEL_HEADER = 'panel-header',
  RESCHEDULE_ACTION = 'reschedule-action',
  REVERSE_ACTION = 'reverse-action',
  START_BLADDER_IRRIGATION = 'start-bladder-irrigation',
}
export { BladderIrrigationViewerAliases };
